(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casa-hero"] && !Shopify.designMode) return;
  try {
    
  class CasaHeroSlider extends HTMLElement {
    connectedCallback() {
      this.pista = this.querySelector('.casa-hero__pista');
      this.slides = [...this.querySelectorAll('.casa-hero__slide')];
      this.puntos = [...this.querySelectorAll('.casa-hero__punto')];
      this.actual = 0;
      if (this.slides.length < 2) return;

      this.querySelectorAll('.casa-hero__flecha').forEach((b) =>
        b.addEventListener('click', () => this.ir(this.actual + parseInt(b.dataset.dir, 10)))
      );
      this.puntos.forEach((p) => p.addEventListener('click', () => this.ir(parseInt(p.dataset.ir, 10))));

      let raf = 0;
      this.pista.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(this.pista.scrollLeft / this.pista.clientWidth);
          if (i !== this.actual) { this.actual = i; this.marcar(); }
        });
      }, { passive: true });

      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.ir(this.actual - 1);
        if (e.key === 'ArrowRight') this.ir(this.actual + 1);
      });

      const ms = parseInt(this.dataset.autoplay || '0', 10);
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (ms >= 3000 && !reduce) {
        const tick = () => { if (!this.pausado && document.visibilityState === 'visible') this.ir(this.actual + 1); };
        this.timer = setInterval(tick, ms);
        ['pointerenter', 'focusin', 'touchstart'].forEach((ev) => this.addEventListener(ev, () => { this.pausado = true; }, { passive: true }));
        ['pointerleave', 'focusout'].forEach((ev) => this.addEventListener(ev, () => { this.pausado = false; }));
      }
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    ir(i) {
      const n = this.slides.length;
      const destino = ((i % n) + n) % n;
      this.pista.scrollTo({ left: destino * this.pista.clientWidth, behavior: 'smooth' });
      this.actual = destino;
      this.marcar();
    }

    marcar() {
      this.puntos.forEach((p, i) => p.setAttribute('aria-selected', i === this.actual ? 'true' : 'false'));
    }
  }

  if (!customElements.get('casa-hero-slider')) {
    customElements.define('casa-hero-slider', CasaHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
